import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { Quotes, Star } from "@phosphor-icons/react";
import { CLIENTS, TESTIMONIALS } from "@/data/company";

export default function Testimonials() {
  return (
    <section
      id="clients"
      className="py-20 lg:py-32 bg-white"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-[2px] bg-[#EA580C]" />
            <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-slate-500">
              Trusted by
            </span>
          </div>
          <h2 className="font-display font-black text-slate-900 text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
            Businesses that <span className="text-slate-400">rely on us.</span>
          </h2>
        </div>

        {/* Client logos marquee */}
        <div className="border-y-2 border-slate-900 bg-[#F1F5F9] py-6 mb-16" data-testid="clients-marquee">
          <Marquee gradient={false} speed={30}>
            {CLIENTS.concat(CLIENTS).map((c, i) => (
              <div
                key={`${c}-${i}`}
                className="mx-8 flex items-center gap-3"
                data-testid={`client-logo-${i}`}
              >
                <span className="w-8 h-8 bg-slate-900 flex items-center justify-center">
                  <span className="text-white font-display font-black text-sm">
                    {c.charAt(0)}
                  </span>
                </span>
                <span className="font-display font-bold text-slate-800 uppercase tracking-wider text-lg whitespace-nowrap">
                  {c}
                </span>
              </div>
            ))}
          </Marquee>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`testimonial-${i}`}
              className="p-8 border-2 border-slate-900 bg-white shadow-brutal hover-shadow-brutal transition-brutal flex flex-col"
            >
              <Quotes size={32} weight="fill" className="text-[#EA580C] mb-4" />
              <p className="text-slate-800 text-base leading-relaxed font-medium flex-1">
                “{t.quote}”
              </p>
              <div className="mt-6 pt-4 border-t border-slate-200">
                <div className="flex items-center gap-1 mb-1 text-[#F59E0B]">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={14} weight="fill" />
                  ))}
                </div>
                <div className="font-display font-black text-slate-900">
                  {t.name}
                </div>
                <div className="text-xs uppercase tracking-widest text-slate-500 mt-0.5">
                  {t.role}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
